export default class ActivateWorkPlanCtrl {
  constructor ($scope, WorkPlanParametrizationSrv, $stateParams, $mdDialog, $interval, $uiGridConstants, i18nService, $cookies, Validations) {
  // CONSTANTS
    const activateWorkPlanVM = this
    i18nService.setCurrentLang('es')
    activateWorkPlanVM.gridActivateWorkPlan = {
      enableFiltering: true,
      columnDefs: [
        {
          name: 'Nombre de profesor',
          displayName: 'Nombre de profesor',
          field: 'teacher_name',
          width: '25%',
          headerCellClass: activateWorkPlanVM.highlightFilteredHeader,
          enableGridMenu: false,
          enableHiding: false,
          enablePinning: false,
          enableColumnMenu: false,
          enableSorting: false,
          cellClass: 'text-xs',
          headerCellClass: 'font-normal text-xs'
        }, {
          name: 'Tipo profesor',
          displayName: 'Tipo profesor',
          field: 'teacher_type',
          width: '25%',
          enableGridMenu: false,
          enableHiding: false,
          enablePinning: false,
          enableColumnMenu: false,
          enableSorting: false,
          cellClass: 'text-xs',
          headerCellClass: 'font-normal text-xs'
        }, {
          name: 'Unidad académica',
          displayName: 'Unidad académica',
          field: 'academic_unit_name',
          width: '20%',
          enableGridMenu: false,
          enableHiding: false,
          enablePinning: false,
          enableColumnMenu: false,
          enableSorting: false,
          cellClass: 'text-xs',
          headerCellClass: 'font-normal text-xs'
        }, {
          name: 'Motivo de bloqueo',
          displayName: 'Motivo de bloqueo',
          field: 'reason',
          width: '15%',
          enableGridMenu: false,
          enableHiding: false,
          enablePinning: false,
          enableColumnMenu: false,
          enableSorting: false,
          cellClass: 'text-xs',
          headerCellClass: 'font-normal text-xs'
        }, {
          name: 'Acciones',
          displayName: 'Acciones',
          field: 'id_state',
          width: '15%',
          enableGridMenu: false,
          enableFiltering: false,
          enableHiding: false,
          enablePinning: false,
          enableColumnMenu: false,
          enableSorting: false,
          cellClass: 'column-center text-xs p-xs cell-button',
          headerCellClass: 'font-normal text-xs column-center',
          cellTemplate: require('./cellActivateWorkPlan.html')
        }
      ],
      onRegisterApi: (gridApi) => {
        activateWorkPlanVM.gridApi = gridApi
        activateWorkPlanVM.gridApi.grid.registerRowsProcessor(activateWorkPlanVM.singleFilter, 200)
        $interval(() => {
          activateWorkPlanVM.gridApi.core.handleWindowResize()
        }, 500, 10)
      }
    }
    

  // VARIABLES
    activateWorkPlanVM.activateWorkPlanFilter = ''
    const user = JSON.parse($cookies.get('currentUser'))
    const currentRoleId = JSON.parse($cookies.get('hasRoleId'))

  // METHODS
    activateWorkPlanVM.singleFilter = singleFilter
    activateWorkPlanVM.filter = filter
    activateWorkPlanVM.returnBack = returnBack

  // MODALS
    activateWorkPlanVM.activateModal = activateModal

  // METHODS DEFINITIONS
    function activate () {
      return getTeacherStateList()
    }

    function getTeacherStateList () {
      let header = { }
      if (Validations.isAdminUnit(currentRoleId) || Validations.isGerencialConsultant(currentRoleId)){
        header.userId = user.id
        header.rolId  = currentRoleId
      } 
      return WorkPlanParametrizationSrv.getTeacherStateList.get(header).$promise.then((dataReturn) => {
        if (dataReturn.status === true) {
          activateWorkPlanVM.gridActivateWorkPlan.data = dataReturn.data
        } else {
          activateWorkPlanVM.gridActivateWorkPlan.data = []
        }
      }).catch((error) => {
        console.error(error)
      })
    }

    function filter () {
      activateWorkPlanVM.gridApi.grid.refresh()
    }
     function returnBack () {
      window.history.back()
    }

    function singleFilter (renderableRows) {
      var matcher = new RegExp(activateWorkPlanVM.activateWorkPlanFilter,'i')
      renderableRows.forEach(function (row) {
        var match = false;
        [ 'teacher_name', 'teacher_type', 'academic_unit_name', 'reason' ].forEach(function (field) {
          if (row.entity[field].match(matcher)) {
            match = true
          }
        })
        if (!match) {
          row.visible = false
        }
      })
      return renderableRows
    }

  // MODAL DEFINITIONS
    function activateModal (teacher) {
      $mdDialog.show({
        controller: ['$scope', '$mdDialog', '$state', function ($scope, $mdDialog, $state) {
          if (teacher.id_state !== 3) {
            $scope.modalHeader = 'Reactivar'
          } else {
            $scope.modalHeader = 'Activar'
          }

          $scope.workplans = []
          $scope.workplan = {}
          $scope.workplanSelected = null
          $scope.workplan.ds_comments = ''
          $scope.submodulesSelected = []
          $scope.selectAllSubmodules = {
            value1 : true,
            value2 : false
          }
          $scope.workplan.dt_limit_for_planning = null
          $scope.workplan.dt_limit_for_approval = null

          $scope.minStarDateApproval = moment().toDate()
          $scope.minStartDatePlanning = moment().toDate()

          $scope.workplan.id_teacher = teacher.teacher_code
          $scope.workplan.teacher_name = teacher.teacher_name
          $scope.workplan.teacher_type = teacher.teacher_type
          $scope.workplan.id_teacher_type = teacher.id_teacher_type
          $scope.workplan.academic_unit = teacher.academic_unit_name
          $scope.workplan.id_academic_unit = teacher.id_academic_unit

          function activate () {
            return getModalData()
          }

          function getModalData () {
            return WorkPlanParametrizationSrv.getTeacherSubmoduleList
            .get({idTeacher: teacher.teacher_code}).$promise.then((dataReturn) => {
              if (dataReturn.status === true) {
                $scope.workplans = getWorkplans(dataReturn.data)
              } else {
                $scope.workplans = []
              }
            })
          }

          function getWorkplans (data) {
            var result = []
            data.forEach(function (professor) {
              var temp = {
                id_work_plan: professor.id_work_plan,
                workplan_name: professor.workplan_name,
                submodules: processSubmoduleInfo(professor.id_submodule.split(','), professor.submodule.split(',')),
                startdate: new Date(professor.startdate),
                enddate: new Date(professor.enddate),
              }
              result.push(temp)
            })
            return result
          }

          function processSubmoduleInfo (submoduleIds, submodules) {
            var result = []
            for (var i in submodules) {
              var temp = {
                submodule_id: submoduleIds[i],
                submodule_name: submodules[i]
              }
              result.push(temp)
            }
            return result
          }

          function processSubmodulesSelected () {
            var ids = []
            var submoduleNames = []
            $scope.submodulesSelected.forEach(function (submodule) {
              for (var subm in $scope.submodules) {
                if ($scope.submodules[subm].submodule_id == submodule.submodule_id) {
                  ids.push($scope.submodules[subm].submodule_id)
                  submoduleNames.push($scope.submodules[subm].submodule_name)
                  break
                }
              }
            })
            $scope.workplan.id_submodule = ids.toString()
            $scope.workplan.submodule = submoduleNames.toString()
          }

          $scope.close = () => {
            $mdDialog.hide()
          }

          $scope.onWorkplanSelected = (workplan) => {
            if (workplan) {
              for (var wp in $scope.workplans) {
                if ($scope.workplans[wp].id_work_plan == workplan.id_work_plan) {
                  $scope.workplan.id_work_plan = workplan.id_work_plan
                  $scope.workplan.workplan_name = workplan.workplan_name
                  $scope.submodules = $scope.workplans[wp].submodules
                  $scope.workplan.startdate = workplan.startdate
                  $scope.workplan.enddate = workplan.enddate
                  break
                }
              }

              if($scope.workplan.startdate < moment().toDate()){
                $scope.workplan.startdate = moment().toDate();
              }

            } else {
              $scope.submodules = null
              $scope.submodulesSelected = []
            }
          }

          $scope.activateOrReactivate = () => {
            processSubmodulesSelected()
            $scope.workplan.dt_limit_for_approval = moment($scope.workplan.dt_limit_for_approval).format('YYYY-MM-DD')
            $scope.workplan.dt_limit_for_planning = moment($scope.workplan.dt_limit_for_planning).format('YYYY-MM-DD')
            $scope.workplan.startdate = moment($scope.workplan.startdate).format('YYYY-MM-DD')
            $scope.workplan.enddate = moment($scope.workplan.enddate).format('YYYY-MM-DD')
            WorkPlanParametrizationSrv.activateWpSubmoduleTeacher.set($scope.workplan).$promise.then((dataReturn) => {
              if (dataReturn.status === true) {
                $state.reload()
                $mdDialog.hide()
                showModalSuccess();
              } else {
                console.log('ERROR')
              }
            })            
          }

          $scope.onSelectAllSubmodules = (selected) => {
            for (var subm in $scope.submodules) {
              $scope.submodulesSelected[subm] = {}
              if (selected.value2 === true) {
                $scope.submodulesSelected[subm].submodule_id = parseInt($scope.submodules[subm].submodule_id)
              } else {
                $scope.submodulesSelected[subm].submodule_id = false
              }
            }
          }

          $scope.onSubmoduleSelected = (submodule) => {
            if (!submodule.submodule_id) {
              $scope.selectAllSubmodules.value2 = false; 
            }
            var todosCheck = true;
            for (var subm in $scope.submodules) {
              if($scope.submodulesSelected[subm].submodule_id === false)
              {
                todosCheck = false;
              }
            }
            if(todosCheck === true)
            {
              $scope.selectAllSubmodules.value2 = true; 
            }
          }

          $scope.planningDateChanged = function () {
            let m = moment($scope.workplan.dt_limit_for_planning)
            $scope.minStarDateApproval = m.isValid() ? m.add(1, 'days').toDate() : null
          }

          $scope.submodulesSelectedEmpty = function () {
            let len = $scope.submodulesSelected.length
            if ( len === 0)
              return true

            for (var i = 0; i < len; i++) {
              if ($scope.submodulesSelected[i] && $scope.submodulesSelected[i].submodule_id)
                return false
            }
            return true
          }

          $scope.hasError = function (input) {
            if (input.$invalid && (input.$dirty || input.$touched)) {
              return 'has-error'
            }
          }

          $scope.showErrorMessages = function (input) {
            if (input !== undefined) {
              return input.$dirty || input.$touched
            } else {
              return false;
            }
          }

          activate()
        }],
        template: require('./modalActivateWorkPlan.html'),
        clickOutsideToClose: false
      })
    }

    function showModalSuccess () {      
      $mdDialog.show({
        controller: ['$scope', '$mdDialog', function ($scope, $mdDialog) {
          let ctrlModal = this          

          $scope.close = function (){            
            $mdDialog.hide();
          }          

        }],
        controllerAs: 'ctrlModal',
        template: require('./modalConfirmActivateWorkPlan.html'),
        clickOutsideToClose: false
      })
    }

  // INITIALIZATION
    activate()
  }// FIN DEL CONStRUCTOR
      preventInput(event){
      var  vKey = 86
       if (event.keyCode == vKey)
            event.preventDefault()
            return;     
    }
}

ActivateWorkPlanCtrl.$inject = ['$scope', 'WorkPlanParametrizationSrv', '$stateParams', '$mdDialog', '$interval', 'uiGridConstants', 'i18nService', '$cookies', 'Validations']



// WEBPACK FOOTER //
// ./src/app/u-faculty/workPlanParametrization/activateWorkPlan/activateWorkPlanCtrl.js